import "simplebar";

export const lineupModals = () => {
  if (document.querySelector(".js-lineup-modal") === null) {
    return;
  }

  const modal = document.querySelector(".js-lineup-modal");
  const modalContents = document.querySelectorAll(".js-lineup-modal-content");
  const modalCloseBtns = document.querySelectorAll(".js-lineup-modal-close");
  const modalOpenBtns = document.querySelectorAll(".js-lineup-modal-open");

  const handleModalClose = () => {
    document.body.classList.remove("is-modal-open");
    modal.classList.remove("is-active");
    modalContents.forEach((content) => content.classList.remove("is-active"));
  };

  modalOpenBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const modalId = btn.dataset.modalId;
      const targetModal = modal.querySelector(`#${modalId}`);

      document.body.classList.add("is-modal-open");
      modal.classList.add("is-active");
      targetModal.classList.add("is-active");
    });
  });

  modal.addEventListener("click", (e) => {
    if (e.target.classList.contains("js-lineup-modal")) {
      handleModalClose();
    }
  });

  modalCloseBtns.forEach((btn) => {
    btn.addEventListener("click", handleModalClose);
  });
};
